<div class="app-container">
  <page-header [icon]="'far fa-analytics'" [title]="'sale.statistics'">
    <ng-container class="header-button">
      <app-exports #exportsModal [entity]="'soldItems'"></app-exports>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="submittedQueryFilters()"
      [filtersForExport]="submittedQueryFilters()"
      [loading]="areCoreDataLoading()"
      [filterVisible]="filtersExpanded"
      [allFilters]="filters()"
      [defaultFilters]="defaultFilters"
      [advancedFilterKeys]="advancedFilterKeys"
      [entity]="'soldItems'"
      [isExportButtonShown]="true"
      (onSubmit)="onFilterSubmit()"
      (onClearClick)="clearFilters()"
      (onCreateModalHidden)="exportsModal.showChildModal()"
      [tags]="queryTags.data()"
      [totalItems]="totalItems()"
      (onExportResult)="querySoldItems.refetch()"
    >
      <div class="row">
        <div class="col-12 col-sm-4 col-md-2">
          <form-row-input
            [label]="'fulltext'"
            [icon]="null"
            [model]="filters().productFulltext"
            (modelChange)="setFilters('productFulltext', $event)"
            (keyup.enter)="onFilterSubmit()"
            [dataCyAttribute]="'sold-items-product-filter'"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-4 col-md-2">
          <form-row-input
            [label]="'orders.customerName'"
            [icon]="null"
            [model]="filters().customerFulltext"
            (modelChange)="setFilters('customerFulltext', $event)"
            (keyup.enter)="onFilterSubmit()"
            [dataCyAttribute]="'sold-items-customer-filter'"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-4 col-md-2">
          <form-row-input
            [label]="'sold-items.date-from'"
            [icon]="null"
            [inputType]="'date'"
            [model]="filters().dateCreated?.left_date"
            (modelChange)="setFilters('dateCreated', $event, 'left_date')"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
          <form-row-input
            [label]="'sold-items.date-to'"
            [icon]="null"
            [inputType]="'date'"
            [model]="filters().dateCreated?.right_date"
            (modelChange)="setFilters('dateCreated', $event, 'right_date')"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-4 col-md-2">
          <form-row-select-multiple
            [label]="'products.checkouts'"
            [options]="queryCheckouts.data()"
            [selectedValues]="filters().checkouts"
            (selectedValuesChange)="setFilters('checkouts', $event)"
          ></form-row-select-multiple>
        </div>
        <div class="col-12 col-sm-4 col-md-2">
          <form-row-select-multiple
            [label]="'products.depots'"
            [options]="queryDepotsOptions.data()"
            [selectedValues]="filters().depots"
            (selectedValuesChange)="setFilters('depots', $event)"
          ></form-row-select-multiple>
        </div>
      </div>
      <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select-multiple
              [label]="'payments'"
              [options]="queryPayments.data()"
              [selectedValues]="filters().payments"
              (selectedValuesChange)="setFilters('payments', $event)"
            ></form-row-select-multiple>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select
              [label]="'order.status'"
              [icon]="null"
              [model]="filters().status"
              (modelChange)="setFilters('status', $event)"
              [options]="statusTypesOptions"
            ></form-row-select>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select
              [label]="'processStatus'"
              [icon]="null"
              [model]="filters().processStatus"
              (modelChange)="setFilters('processStatus', $event)"
              [options]="processStatesOptions"
            ></form-row-select>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select-multiple
              [label]="'carriers'"
              [selectedValues]="filters().carriers"
              (selectedValuesChange)="setFilters('carriers', $event)"
              [options]="queryCompanyCarriers.data()"
            ></form-row-select-multiple>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select-multiple
              [label]="'orderTags'"
              [options]="orderTags"
              [selectedValues]="filters().orderTags"
              (selectedValuesChange)="setFilters('orderTags', $event)"
            ></form-row-select-multiple>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select-multiple
              [label]="'productTags'"
              [options]="productTags"
              [selectedValues]="filters().productTags"
              (selectedValuesChange)="setFilters('productTags', $event)"
            ></form-row-select-multiple>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select-multiple
              [label]="'producers'"
              [options]="queryProducers.data()"
              [selectedValues]="filters().producers"
              (selectedValuesChange)="setFilters('producers', $event)"
            ></form-row-select-multiple>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select-multiple
              [label]="'suppliers'"
              [options]="querySuppliers.data()"
              [selectedValues]="filters().suppliers"
              (selectedValuesChange)="setFilters('suppliers', $event)"
            ></form-row-select-multiple>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-input
              [label]="'sold-items.date-bill-from'"
              [icon]="null"
              [inputType]="'date'"
              [model]="filters().dateBill?.left_date"
              (modelChange)="setFilters('dateBill', $event, 'left_date')"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
            <form-row-input
              [label]="'sold-items.date-bill-to'"
              [icon]="null"
              [inputType]="'date'"
              [model]="filters().dateBill?.right_date"
              (modelChange)="setFilters('dateBill', $event, 'right_date')"
            ></form-row-input>
          </div>
        </div>
      </div>
    </app-filter-form>
    <app-base-listing
      [listName]="'soldItems'"
      [query]="querySoldItems"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [filters]="submittedViewFilters()"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
      [loadStringifiedFilters]="true"
      [stringifiedFilters]="stringifiedFilters()"
    ></app-base-listing>
  </section>
</div>
